export class RequestById{
    requestId: number;

    /**
     * 
     * @param requestId 
     */
    constructor(requestId: number){
        this.requestId = requestId;


    }
}